<script>
	import { onMount } from 'svelte'
	import axios from 'axios'
	import Button from '../shared/Button.svelte'
	
	export let bot

	/*const channels = await bot.get('/channels')*/

	let servers = {},
		message,
		server,
		channel,
		channelID

	$: console.log(servers)
	$: console.log(channelID)
	$: channelID = channel ? channel.id : null

	onMount(async() => {
		let r = await bot.get('/channels')
		servers = r.data
	})

	/*let getChannels = async () => {
		let channels = await bot.get('/channels')
		return channels
	}*/

	let submit = () => {
		if (Boolean(message) && Boolean(channelID)) {
			bot.post('/sockpuppet/message', {
				'channelID' : channelID,
				'msg': message
			}).then(r => {
				console.log(r)
			}).catch(e => {
				console.log(e)
			})

			message = null
			channel = null
		}	
	}
</script>

<div class='tool message-sockpuppet'>
	<h3>Discord message sockpuppet</h3>
	<p>
		Posts a message on a Discord channel through roby.
	</p>
	<form on:submit|preventDefault={submit}>
		<label for='channel'>📬 channel</label>
		<select name='channel' bind:value={channelID}>
			{#each Object.entries(servers) as [server, channels]}
			 	<optgroup label={server}>
					{#each channels as channel}
						<option value={ channel.id }>{ channel.name }</option>
					{/each}
				 </optgroup>
				{:else}
				<option>nothing</option>
			{/each}
		</select>

		<label for='message'>✉️ message</label>
		<input name='message' type='text' bind:value={message} placeholder='message to post'>

		<Button>Publish on Discord</Button>
	</form>
</div>

<style>
	
</style>